import { ControlValueAccessor, FormControl, NgControl } from '@angular/forms';
import { Component, EventEmitter, Input, Optional, Output, Self } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { MaskitoElementPredicate, MaskitoOptions } from '@maskito/core';

@Component({
    selector: 'c-input',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.scss'],
    standalone: false
})
export class InputComponent<T = any> implements ControlValueAccessor {
  @Input() type: 'date' | 'email' | 'number' | 'password' | 'search' | 'tel' | 'text' | 'time' | 'hidden' | 'url' =
    'text';
  @Input() inputMode: 'numeric' | 'decimal' | 'text' = this.type === 'number' ? 'numeric' : 'text';
  @Input() label: string | undefined;
  @Input() hidden: boolean | undefined;
  @Input() placeholder: string | undefined;
  @Input() readonly: boolean | undefined;
  @Input() showIcon: boolean;
  @Input() loading: boolean | undefined;
  @Input() minLength: number | undefined;
  @Input() maxLength: number | undefined;
  @Input() showError = true;
  @Input() noBorder: boolean;
  @Input() clearInput = false;
  @Input() icon: string | IconProp;
  @Input() iconColor = 'dark';
  @Input() iconStart = false;
  @Input() maskito: MaskitoOptions | undefined;

  @Output() action = new EventEmitter<void>();

  readonly maskPredicate: MaskitoElementPredicate = async (el) => ((el as unknown) as HTMLIonInputElement).getInputElement();

  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  iconClick(): void {
    this.action.emit();
  }

  get hasErrors(): boolean {
    return this.showError && this.control?.errors && this.control?.touched;
  }

  get control() {
    return this.ngControl?.control as FormControl;
  }

  writeValue(value: any): void {}

  onChange = (value: T) => {};
  onTouched = () => {};

  registerOnChange(fn: (value: T) => void): void {
    this.onChange = fn;
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  registerOnTouched(fn: () => {}): void {
    this.onTouched = fn;
  }
}
